
export const CaseStates = Object.freeze({
    "CLOSED":1,
    "IN_PROGRESS":2,
    "FACTORY_PROCESS":3,
    "RACE_TRACING":4,
    "PAU_TRACING":5,
    "NOT_MANAGED": 6,
    "MAINTENANCE_TRACING": 7,
    "FACTORY_PROCESS_RETURN": 8,
    "CIC_TRACING": 9,
    "CIC_FACTORY_PROCESS": 10,
})
